import { render, staticRenderFns } from "./InvoicesPlaceholder.vue?vue&type=template&id=337bc114&scoped=true&"
import script from "./InvoicesPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./InvoicesPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesPlaceholder.vue?vue&type=style&index=0&id=337bc114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337bc114",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow})
